import React from "react";
import { Formik, Field, Form, FormikHelpers, ErrorMessage } from "formik";
import * as Yup from "yup";
import Tab from "./Tab";
import Tabs from "./Tabs";
import { updateFormState, updateStep } from "../userSlice";
import { useAppDispatch } from "../store/hooks";

interface Values {
  email: string;
  fullName: string;
  iban: string;
  swift: string;
  accountNumber: number;
}

interface Props {
  handleNext: () => void;
}
const Recipient = ({ handleNext }: Props) => {
  const dispatch = useAppDispatch();

  const handleSubmit = (
    values: Values,
    { setSubmitting }: FormikHelpers<Values>
  ) => {
    dispatch(updateFormState(values));
    setSubmitting(false);
    dispatch(updateStep(1));
    handleNext();
  };

  return (
    <>
      <div className="flex justify-center ">
        <div className=" bg-white mt-16  mb-6 container rounded-md p-8 lg:w-2/5">
          <div className="">
            <h1 className="text-base font-medium text-blue-dark">
              Your Recipient
            </h1>
            <p className="text-sm text-grey-dim">
              Who are you sending money to?
            </p>
          </div>

          <hr className=" border-grey-light my-5" />
          <Formik
            initialValues={{
              email: "",
              fullName: "",
              iban: "",
              swift: "",
              accountNumber: 0,
            }}
            validationSchema={Yup.object({
              email: Yup.string()
                .email("Invalid email address")
                .required("Required"),
              fullName: Yup.string()
                .max(30, "Must be 15 characters or less")
                .required("Required"),
              iban: Yup.string()
                .max(10, "Must be 10 characters")
                .required("Required"),
              swift: Yup.string().max(10, "Must be 10 characters"),
              accountNumber: Yup.number().max(10, "Must be 10 characters"),
            })}
            onSubmit={handleSubmit}
          >
            <Form>
              <div className=" mb-5">
                {/* eslint-disable-next-line  jsx-a11y/label-has-associated-control */}
                <label htmlFor="email" className="block mb-3">
                  <span className="text-xs text-grey-dim">
                    Their email (optional)
                  </span>
                  <div className="border border-grey-light flex rounded">
                    <Field
                      type="email"
                      id="email"
                      name="email"
                      className=" px-4 py-2   w-full rounded outline-none"
                    />
                  </div>
                  <span className="text-xs">
                    <ErrorMessage name="email" />
                  </span>
                </label>

                {/* eslint-disable-next-line  jsx-a11y/label-has-associated-control */}
                <label htmlFor="fullName" className="">
                  <span className="text-xs text-grey-dim">
                    Full name of the account holder
                  </span>
                  <div className="border border-grey-light flex rounded">
                    <Field
                      type="fullName"
                      id="fullName"
                      name="fullName"
                      className=" px-4 py-2   w-full rounded outline-none"
                    />
                  </div>
                  <span className="text-xs">
                    <ErrorMessage name="fullName" />
                  </span>
                </label>
              </div>
              <h1 className="text-sm font-medium text-blue-dark">
                Bank details
              </h1>
              <hr className=" border-grey-light my-5" />
              <Tabs>
                <Tab title="Inside Europe">
                  {/* eslint-disable-next-line  jsx-a11y/label-has-associated-control */}
                  <label htmlFor="name" className="block mt-2">
                    <span className="text-sm">IBAN</span>
                    <div className="border border-grey-light flex rounded">
                      <Field
                        type="iban"
                        id="iban"
                        name="iban"
                        placeholder="Recipient gets"
                        className=" px-4 py-2   w-full rounded outline-none"
                      />
                    </div>
                    <span className="text-xs">
                      <ErrorMessage name="iban" />
                    </span>
                  </label>
                </Tab>
                <Tab title="Outside Europe">
                  {/* eslint-disable-next-line  jsx-a11y/label-has-associated-control */}
                  <label htmlFor="name" className="block mt-6">
                    <span className="text-sm text-grey-dim">
                      SWIFT / BIC code
                    </span>
                    <div className="border border-grey-light flex rounded">
                      <Field
                        type="swift"
                        id="swift"
                        name="swift"
                        placeholder="BUKBGB22"
                        className=" px-4 py-2   w-full rounded outline-none"
                      />
                    </div>
                    <span className="text-xs">
                      <ErrorMessage name="swift" />
                    </span>
                  </label>

                  {/* eslint-disable-next-line  jsx-a11y/label-has-associated-control */}
                  <label htmlFor="name" className="block mt-6">
                    <span className="text-sm text-grey-dim">
                      IBAN / Account Number
                    </span>
                    <div className="border border-grey-light flex rounded">
                      <Field
                        type="accountNumber"
                        id="accountNumber"
                        name="accountNumber"
                        placeholder="01234567891"
                        className=" px-4 py-2   w-full rounded outline-none"
                      />
                    </div>
                    <span className="text-xs">
                      <ErrorMessage name="accountNumber" />
                    </span>
                  </label>
                </Tab>
              </Tabs>
              <div className=" flex justify-between mt-6">
                <button
                  type="submit"
                  className="h-12 bg-gray-200 w-full rounded text-sm text-white bg-blue"
                >
                  Continue
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
};

export default Recipient;
